import DocumentsChartService from '@/modules/dashboard/services/documentsChartService'
import { getArrayMontly } from './documentsChartStoreUtils'

export default {
  namespaced: true,
  state: () => {
    return {
      statisticsData: {},
      statisticsYears: [],
      statisticsLoading: false,
      statisticsError: false,
      statisticsMessage: '',
      statisticsTitles: {
        createdYearly: 'CREADOS ANUAL',
        statusYearly: 'ESTATUS ANUAL',
        statusMonthly: 'ESTATUS MENSUAL'
      },
      statisticsSizes: {
        cardWidth: { true: 950, false: 600 },
        cardHeight: { true: 630, false: 320 },
        chartHeight: { true: 580, false: 290 }
      },
      statisticsLabelsMonthly: [
        'Ene',
        'Feb',
        'Mar',
        'Abr',
        'May',
        'Jun',
        'Jul',
        'Ago',
        'Sep',
        'Oct',
        'Nov',
        'Dic'
      ],
      statisticsColors: [
        '#B2DFDB',
        '#80CBC4',
        '#00cdd2',
        '#00b4b8',
        '#009b9f',
        '#008285',
        '#00696c',
        '#008285',
        '#009b9f',
        '#00b4b8',
        '#00cdd2',
        '#00e6eb'
      ]
    }
  },
  mutations: {
    SET_STATISTICS_LOADING(state, loading) {
      state.statisticsLoading = loading
    },
    SET_STATISTICS_DATA(state, data) {
      state.statisticsData = data
    },
    SET_STATISTICS_ERROR(state, err) {
      state.statisticsError = err
    },
    SET_STATISTICS_MESSAGE(state, msg) {
      state.statisticsMessage = msg
    },
    SET_STATISTICS_YEARS(state, years) {
      state.statisticsYears = years
    }
  },
  actions: {
    getDocumentStatistics({ commit }, year) {
      commit('SET_STATISTICS_LOADING', true)
      commit('SET_STATISTICS_MESSAGE', '')

      const service = new DocumentsChartService()
      service
        .getDocumentStatistics(year)
        .then(resp => {
          const data = resp.data.data

          let created = getArrayMontly('creados_', data)
          let pending = getArrayMontly('pendientes_', data)
          let progress = getArrayMontly('enproceso_', data)
          let erased = getArrayMontly('borrados_', data)
          let signed = getArrayMontly('firmados_', data)
          let expired = getArrayMontly('expirados_', data)

          let statistics = {
            anio: +data.anio,
            total_creados: +data.total_creados,
            total_pendientes: +data.total_pendientes,
            total_en_proceso: +data.total_en_proceso,
            total_borrados: +data.total_borrados,
            total_firmados: +data.total_firmados,
            total_expirados: +data.total_expirados,
            creados: created,
            pendientes: pending,
            enproceso: progress,
            borrados: erased,
            firmados: signed,
            expirados: expired
          }
          commit('SET_STATISTICS_DATA', statistics)
        })
        .catch(() => {
          commit('SET_STATISTICS_ERROR', true)
          commit('SET_STATISTICS_MESSAGE', 'No hay información para mostrar')
        })
        .finally(() => {
          commit('SET_STATISTICS_LOADING', false)
        })
    },
    getYearsDocStatistics({ commit }) {
      commit('SET_STATISTICS_LOADING', true)
      commit('SET_STATISTICS_MESSAGE', '')

      const service = new DocumentsChartService()
      service
        .getYearsDocStatistics()
        .then(resp => {
          const data = resp.data.data
          let years = []
          for (let item in data) {
            years.push(data[item])
          }

          commit('SET_STATISTICS_YEARS', [...years].reverse())
        })
        .catch(() => {
          commit('SET_STATISTICS_ERROR', true)
          commit('SET_STATISTICS_MESSAGE', 'No hay información para mostrar')
        })
        .finally(() => {
          commit('SET_STATISTICS_LOADING', false)
        })
    }
  },
  getters: {
    statisticsData(state) {
      return state.statisticsData
    },
    statisticsLoading(state) {
      return state.statisticsLoading
    },
    statisticsError(state) {
      return state.statisticsError
    },
    statisticsMessage(state) {
      return state.statisticsMessage
    },
    statisticsTitles(state) {
      return state.statisticsTitles
    },
    statisticsSizes(state) {
      return state.statisticsSizes
    },
    statisticsYears(state) {
      return state.statisticsYears
    },
    statisticsColors(state) {
      return state.statisticsColors
    },
    statisticsLabelsMonthly(state) {
      return state.statisticsLabelsMonthly
    }
  }
}
